import axiosInstance from "../axiosInstance";

// Per-client forecast settings (control-tower api/forecast-policy/:clientId).
export const forecastPolicyService = {
  get: async (clientId) => {
    const response = await axiosInstance.get(`/forecast-policy/${clientId}`);
    return response.data;
  },
  save: async (clientId, changes) => {
    const response = await axiosInstance.patch(`/forecast-policy/${clientId}`, changes);
    return response.data;
  },
  reset: async (clientId) => {
    const response = await axiosInstance.delete(`/forecast-policy/${clientId}`);
    return response.data;
  },
};
